import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { fetchMessageSessionAction } from '../fetchMessageSession/action';

export function* updateConversationNameSaga(action) {
    const { messageSessionId, newSessionName } = action.payload;
    
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const response = yield call(cirrusClient.put, 
            `/v2/domains/${domain}/users/${user}/messagesessions/${messageSessionId}`,
            { 'session-name': newSessionName }
        );

        if (response.status === 202) {
            // Refresh message sessions to get updated data
            yield put(fetchMessageSessionAction());
            
            yield put(showSnackbar({
                message: 'Conversation name updated successfully.',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error updating conversation name:', error);
        yield put(showSnackbar({
            message:'Failed to update conversation name',
            severity: 'error'
        }));
    }
}